import React from 'react';
import { Link } from 'react-router-dom';

const SingleItem = ({ data, handleDelete, handleDuplicate }) => {
    return (
        <>
            <tr>
                <td data-label="Name">
                    {data?.name}
                </td>
                <td data-label="Name">
                    {data?.platformTypeId?.name}
                </td>


                <td data-label="Action">
                    <Link to={`/admin/order-set/edit/${data?._id}`} class="btn btn-sm btn-outline-primary"><i class="la la-pencil-alt"></i>Manage</Link>
                    <button onClick={()=>handleDuplicate(data?._id)}  class="btn btn-sm btn-outline-success mx-1"><i class="la la-copy"></i>Duplicate</button>
                    <button class="btn btn-sm btn-outline-danger " onClick={() => handleDelete(data?._id)} ><i class="la la-trash"></i> Remove</button>
                </td>
            </tr>
        </>
    );
};

export default SingleItem;